import script from "./service-order-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-order-detail.vue?vue&type=script&lang=ts&setup=true"

import "./service-order-detail.vue?vue&type=style&index=0&id=37548387&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37548387"]])

export default __exports__